import { render, staticRenderFns } from "./OrderInvoiceDetail.vue?vue&type=template&id=4239582c&scoped=true&"
import script from "./OrderInvoiceDetail.vue?vue&type=script&lang=js&"
export * from "./OrderInvoiceDetail.vue?vue&type=script&lang=js&"
import style0 from "./OrderInvoiceDetail.vue?vue&type=style&index=0&id=4239582c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4239582c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VSimpleTable})
